import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';
import type { UserPreferenceTheme } from '../user-preference';

import type { UserUpdatePreferenceRequest } from './schema';

const themes: UserPreferenceTheme[] = [
  'dark',
  'light',
  'system',
  'contrast-dark',
];

export const preferenceUpdateSchema = yup.object<
  ObjectType<UserUpdatePreferenceRequest>
>({
  theme: yup.string().oneOf(themes).required(),
});
